import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/unit-price-calculator',
  component: () => import('../../routes/UnitPriceCalculator.svelte'),
  card: {
    id: 'unit-price-calculator',
    title: 'Unit Price Calculator',
    description: 'Compare price per unit across different products and sizes to find the best deal.',
    icon: 'scale',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/unit-price-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Unit Price Calculator – Compare Price Per Unit to Find the Best Deal',
    description: 'Free unit price calculator to compare price per ounce, pound, gallon, and more. Find the best value by calculating cost per unit across different products and package sizes.',
  },
};

export default meta;
